import { TemplateStep } from './enums/templateStep';
import TemplateType from './enums/templateType';
import { Tag } from './tag';

export interface Template {
  id: number;
  userId: number;
  subscriptionId: number;
  title: string;
  subject: string;
  content: string;
  language: string;
  type: TemplateType;
  step?: TemplateStep;
  shared: boolean;
  useCount: number;
  openCount: number;
  answerCount: number;
  templateTags?: Tag[];
  usedForProspect?: boolean | null;
  strategyStepTemplateId?: number | null;

  isPersonalized?: boolean;
  personalizedWithAI?: boolean;
  isGeneratedWithAi?: boolean;
  personalizedTemplateId?: number | null;
  recordingDuration?: number;
  archived?: boolean;
  isSingleUse?: boolean;
}

export enum TemplateVariables {
  PROSPECT_NAME = '{{PROSPECT_NAME}}',
  PROSPECT_SURNAME = '{{PROSPECT_SURNAME}}',
  PROSPECT_TITLE = '{{PROSPECT_TITLE}}',
  COMPANY_NAME = '{{COMPANY_NAME}}',
  USER_NAME = '{{USER_NAME}}',
  USER_SURNAME = '{{USER_SURNAME}}',
  USER_COMPANY_NAME = '{{USER_COMPANY_NAME}}',

  //Additional ones
  PROSPECT_TIMEZONE = '{{PROSPECT_TIMEZONE}}',
  PROSPECT_LOCATION = '{{PROSPECT_LOCATION}}',
  PROSPECT_OWNER = '{{PROSPECT_OWNER}}',
  COMPANY_WEBSITE = '{{COMPANY_WEBSITE}}',
  COMPANY_SIZE = '{{COMPANY_SIZE}}',
  COMPANY_INDUSTRY = '{{COMPANY_INDUSTRY}}',
  COMPANY_COUNTRY = '{{COMPANY_COUNTRY}}',
  COMPANY_OWNER = '{{COMPANY_OWNER}}',
}
